// Single source of truth for app version
// Update this file when releasing a new version
export const APP_VERSION = 'v0.42.3';
